import { addLastPrefixIT } from '../transforms/addLastPrefix';
import { capitalizeFirstLetter } from '../transforms/capitalizeFirstLetter';
import { overrideBaseLocale } from './base-config';
export var itIT = overrideBaseLocale('it-IT', {
    dayOfWeekLongPropercase: {
        options: {
            weekday: 'long',
        },
        transforms: [capitalizeFirstLetter],
    },
    dayOfWeekShortPropercase: {
        options: {
            weekday: 'short',
        },
        transforms: [capitalizeFirstLetter],
    },
    lastDayOfWeekLong: {
        options: {
            weekday: 'long',
        },
        transforms: [addLastPrefixIT, capitalizeFirstLetter],
    },
    monthLongPropercase: {
        options: {
            month: 'long',
        },
        transforms: [capitalizeFirstLetter],
    },
    monthShortPropercase: {
        options: {
            month: 'short',
        },
        transforms: [capitalizeFirstLetter],
    },
});
//# sourceMappingURL=it-IT.js.map